export { getKeyCodeFromEvent, isKeycode, isKeypress } from "./KeyCheck";
export { default as KeyboardCodes } from "./KeyboardCodes";
